import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import datadogRum from 'utils/datadog';

// project imports
import useAuth from 'hooks/useAuth';

if (process.env.REACT_APP_ENVIRONMENT === 'production') {
  Sentry.init({
    dsn: 'https://3e4c5b3fcac801fcc553c77e1c5791b6@o4506189134888960.ingest.sentry.io/4506200663130112',
    replaysSessionSampleRate: 1.0,
    integrations: [
      new Sentry.Replay({
        networkDetailAllowUrls: [''],
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
      }),
    ],
  });
}
if (process.env.REACT_APP_DATADOG_APPLICATION_ID && process.env.REACT_APP_DATADOG_CLIENT_TOKEN) {
  datadogRum.init({
    applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID,
    clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'preceptorlink-admin',
    env: process.env.REACT_APP_ENVIRONMENT || process.env.REACT_APP_TARGET_ENV || process.env.NODE_ENV,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'allow',
  });
}
// -----------------------|| AUTH GUARD ||----------------------- //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }) => {
  const { isLoggedIn, user, logout } = useAuth();

  useEffect(() => {
    if (process.env.REACT_APP_ENVIRONMENT === 'production' && user?.email) {
      Sentry.setUser({
        email: user?.email,
      });
    }
    if (user?.email) datadogRum.setUser({ id: user.email, email: user.email });
  }, [user]);

  if (!isLoggedIn) {
    return <Redirect to="/login/" />;
  } if (user?.email && !/preceptorlink\.com|productera\.io|inveritasoft\.com|keplercode\.com|mccomasconstruction|amopportunities\.org|samuelmerritt\.edu/.test(user?.email)) {
    logout();
  }

  return children;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default AuthGuard;
